import * as React from 'react';
import loadable from '@loadable/component';
import { Helmet } from 'react-helmet-async';
import { SEO_CONSTANTS } from '../../ListingPage/services/seo/constant';
import withMicroFrontendProps from 'Common/Microfrontend';

const SignupAndLogin = loadable(() => import('mf-signup-and-login/Main'), { ssr: false });

const SignupAndLoginWithBellaProps = withMicroFrontendProps(SignupAndLogin, 'mf-signup-and-login');

const SignupAndLoginMicroFrontend = () => (
    <div>
        <Helmet>
            <meta name={SEO_CONSTANTS.robotsMetaName} content={SEO_CONSTANTS.noIndexable} />
        </Helmet>
        <SignupAndLoginWithBellaProps />
    </div>
);

// TODO[P100-3667]: only for dev/review, should be removed
const LoginAndRegistration = loadable(() => import('mf-signup-and-login/Auth'), { ssr: false });
const LoginAndRegistrationWithBellaProps = withMicroFrontendProps(LoginAndRegistration, 'mf-signup-and-login');
const LoginAndRegistrationMicroFrontend = () => (
    <div>
        <Helmet>
            <meta name={SEO_CONSTANTS.robotsMetaName} content={SEO_CONSTANTS.noIndexable} />
        </Helmet>
        <LoginAndRegistrationWithBellaProps />
    </div>
);

export { LoginAndRegistrationMicroFrontend };
export default SignupAndLoginMicroFrontend;
